import './hampshirehe5/style';
import FormStructure from './hampshirehe5/form_structure';

export default FormStructure;